import React, { useState } from 'react';
import axios from '../api'; // ou import axios from 'axios'

export default function ImportCSV({ onImported }) {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Veuillez sélectionner un fichier CSV.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file); // clé 'file' obligatoire !

    try {
      // Pas de Content-Type manuel : le navigateur ajoute automatiquement
      // le boundary multipart, indispensable pour que multer parse le fichier
      const res = await axios.post('/import/bank-csv', formData);
      const { inserted, uncategorized_merchants } = res.data;
      let msg = `${inserted} transaction${inserted !== 1 ? 's' : ''} importée${inserted !== 1 ? 's' : ''}.`;
      if (uncategorized_merchants?.length > 0)
        msg += ` ⚠️ Marchands sans catégorie : ${uncategorized_merchants.join(', ')}.`;
      setMessage(msg);

      if (onImported) onImported();
    } catch (err) {
      console.error(err);
      setMessage('Erreur lors de l’import CSV.');
    }
  };

  return (
    <div>
      <h2>Importer un CSV bancaire</h2>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={handleUpload}>Importer</button>
      {message && <p>{message}</p>}
    </div>
  );
}
